module.exports = __webpack_public_path__ + "static/media/SearchPageGraphic.6b2866ef.svg";